import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, Input, Button, LoadingSpinner } from '../components/ui';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login, bootstrap, setupRequired } = useAuth();
  const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
  const [name, setName] = useState('');
  const [setupKey, setSetupKey] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');

    if (setupRequired && password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    const result = setupRequired
      ? await bootstrap(name, email, password, setupKey)
      : await login(email, password);

    setLoading(false);

    if (!result.success) {
      setError(result.error || 'Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardContent>
          <h1 className="text-2xl font-bold text-white mb-2">Subscription Manager</h1>
          <p className="text-dark-400 mb-6">
            {setupRequired ? 'Create your root admin account' : 'Sign in to continue'}
          </p>
          <div className="mb-5 rounded-lg border border-dark-700 bg-dark-800/60 p-3">
            <p className="text-sm text-dark-300">
              New here? Read what this app does
              {' '}
              <Link
                to="/about"
                className="text-primary-400 hover:text-primary-300 underline"
              >
                here
              </Link>
              .
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {setupRequired ? (
              <Input
                label="Name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Root Admin"
                required
              />
            ) : null}
            <Input
              label="Username / Email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={isLocalHost ? 'demouser or you@example.com' : 'you@example.com'}
              required
            />
            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
            {setupRequired ? (
              <>
                <Input
                  label="Confirm Password"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
                <Input
                  label="Setup Key"
                  type="password"
                  value={setupKey}
                  onChange={(e) => setSetupKey(e.target.value)}
                  placeholder="Required if AUTH_SETUP_KEY is configured"
                />
              </>
            ) : null}
            {error ? <p className="text-sm text-red-400">{error}</p> : null}
            <Button
              type="submit"
              className="w-full"
              disabled={
                loading
                || !email
                || !password
                || (setupRequired && (!name || !confirmPassword))
              }
            >
              {loading ? <LoadingSpinner size="sm" /> : (setupRequired ? 'Create Root Account' : 'Login')}
            </Button>
          </form>

        </CardContent>
      </Card>
    </div>
  );
}
